import React from "react";
import { Breadcrumb } from "react-bootstrap";
import AdminDashboardComp from "../../components/Admin/AdminDashboard";

export default function AdminDashboard() {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <h3 className="mb-0">داشبورد مدیریت</h3>

        <Breadcrumb className="breadcrumb-page-list align-items-center mb-0 lh-1">
          <Breadcrumb.Item active href="/admin/dashboard">
            <div className="d-flex align-items-center text-decoration-none">
              <i className="ri-home-4-line fs-18 text-primary me-1"></i>
              <span className="text-secondary fw-medium hover">داشبورد مدیریت</span>
            </div>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <AdminDashboardComp />
    </>
  );
}
